import { render, staticRenderFns } from "./historyurlselecter.vue?vue&type=template&id=8bb8b2b6&scoped=true&"
import script from "./historyurlselecter.vue?vue&type=script&lang=js&"
export * from "./historyurlselecter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb8b2b6",
  null
  
)

export default component.exports